import { createGetDataReducer } from "./CommonReducer";
import {
  SUBSCRIPTION_PAYMENT_LIST,
  SUBSCRIPTION_PAYMENT_APPROVE,
  SUBSCRIPTION_PAYMENT_REJECT,
  OFFLINE_BANK_SETTINGS_GET,
  OFFLINE_BANK_SETTINGS_UPDATE,
} from "../../Constants/SubscriptionPaymentConstants";

export const SubscriptionPaymentListReducer = createGetDataReducer(SUBSCRIPTION_PAYMENT_LIST);
export const SubscriptionPaymentApproveReducer = createGetDataReducer(SUBSCRIPTION_PAYMENT_APPROVE);
export const SubscriptionPaymentRejectReducer = createGetDataReducer(SUBSCRIPTION_PAYMENT_REJECT);
export const OfflineBankSettingsGetReducer = createGetDataReducer(OFFLINE_BANK_SETTINGS_GET);
export const OfflineBankSettingsUpdateReducer = createGetDataReducer(OFFLINE_BANK_SETTINGS_UPDATE);
